import { render, staticRenderFns } from "./UpdateNews.vue?vue&type=template&id=5f10d224&"
import script from "./UpdateNews.vue?vue&type=script&lang=ts&"
export * from "./UpdateNews.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports